<template>
    <DataTable
        :header="$t('productsCurrentlyNotAvailable')"
        :fields="fields"
        :items="items"
        :loading="request.getLoading()"
        :error="request.getError()"
        show-export-button
        class="mb-4"
    />
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'CurrentUnavailableProducts',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestCurrentUnavailableProducts,
            };
        },
        computed: {
            data() {
                return this.request.getData() || {};
            },
            fields() {
                return [
                    { key: 'name', label: this.$t('product'), sortable: true, exportable: true },
                    { key: 'category', label: this.$t('category'), sortable: true, exportable: true, show: false },
                    { key: 'subcategory1', label: this.$t('subcategory1'), sortable: true, exportable: true, show: false },
                    { key: 'subcategory2', label: this.$t('subcategory2'), sortable: true, exportable: true, show: false },
                    { key: 'subcategory3', label: this.$t('subcategory3'), sortable: true, exportable: true, show: false },
                    { key: 'subcategory4', label: this.$t('subcategory4'), sortable: true, exportable: true, show: false },
                    { key: 'sku', label: this.$t('model'), sortable: true, exportable: true },
                    { key: 'ean', label: this.$t('ean'), sortable: true, exportable: true },
                    { key: 'lastAvailableAt', label: this.$t('lastAvailability'), sortable: true, exportable: true },
                    { key: 'daysUnavailable', label: this.$t('notAvailableByNumberOfDays'), sortable: true, exportable: true },
                ];
            },
            items() {
                const items = [];
                Object.values(this.data).forEach(productObj => {
                    const product = productObj.product || {};
                    let category = '';
                    let subcategory1 = '';
                    let subcategory2 = '';
                    let subcategory3 = '';
                    let subcategory4 = '';
                    if (product.categories && product.categories.length > 0 && product.categories[0].length > 0) {
                        const categories = [...product.categories[0]].reverse();
                        category = categories[0]?.name || '';
                        subcategory1 = categories[1]?.name || '';
                        subcategory2 = categories[2]?.name || '';
                        subcategory3 = categories[3]?.name || '';
                        subcategory4 = categories[4]?.name || '';
                    }
                    const lastAvailableAt = productObj.lastAvailableAt;
                    const formattedDate = lastAvailableAt ? new Date(lastAvailableAt).toISOString().slice(0, 10) : '';
                    let daysUnavailable = '';
                    if (lastAvailableAt) {
                        const diffMs = new Date() - new Date(lastAvailableAt);
                        daysUnavailable = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
                    }
                    items.push({
                        category,
                        subcategory1,
                        subcategory2,
                        subcategory3,
                        subcategory4,
                        name: product.name || '',
                        sku: product.sku || '',
                        ean: product.ean || '',
                        lastAvailableAt: formattedDate,
                        daysUnavailable,
                    });
                });
                return items;
            },
        },
    };
</script>
